import { readSingle } from './read'
import { resourceObject } from './resourceObject'
import { update } from './update'

export const stories = {
  createResource: resourceObject,
  readSingle,
  update,
}
